import { environmentConfig } from "@src/appV2/environment";
import { logApiFailureEvent } from "@src/lib/analytics";
import request from "superagent";

import { AgentVersionRequest } from "./model";
import { getAuthHeader } from "../superagent";

const updateAgentVersion = async (req: AgentVersionRequest): Promise<void> => {
  return await request
    .post(`${environmentConfig.REACT_APP_WORKER_SERVICE_URL}/agentprofile/version`)
    .set(await getAuthHeader())
    .send(req)
    .then(({ body }) => body)
    .catch(logApiFailureEvent);
};

export { updateAgentVersion };
